<template>
  <kst-print-table :data="items">
    <b-table-column
      v-slot="{ column, row }"
      field="DispatchID"
      :label="SpadItemCatalog.DispatchID.ColumnLabel"
    >
      <kst-value :field="column.field" :data="row" :catalog="SpadItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-sku-large"
      field="SKU"
      :label="SpadItemCatalog.SKU.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="SpadItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-qty-print"
      field="Qty"
      :label="SpadItemCatalog.Qty.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="SpadItemCatalog">
        <kst-value field="Packaging" :data="row" :catalog="SpadItemCatalog"/>
      </kst-value>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-price"
      field="SellPrice"
      :label="SpadItemCatalog.SellPrice.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="SpadItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-specialpricename"
      field="SpecialPriceID"
      :label="SpadItemCatalog.SpecialPriceID.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="SpadItemCatalog"/>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="Total"
      :label="SpadItemCatalog.Total.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="SpadItemCatalog"/>
    </b-table-column>
  </kst-print-table>
</template>

<script>
import SpadItemCatalog from "../SpadItemCatalog.js";

export default {
  props: {
    items: Array
  },
  data: () => ({
    SpadItemCatalog: SpadItemCatalog
  })
}
</script>